import {
    GET_ALL_TICKETS,
} from '../actions/TicketActions'

const initialState = {
    data: [],
    allTickets: [],
    latestUpdate: '',
    loading: false,
    error: '',
}

const TicketReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_ALL_TICKETS: {
            return {
                ...state,
                allRoles: action.payload,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default TicketReducer
